import { createEvent, createStore, sample } from 'effector';
import type { SortDir } from './clients-filter.entity';
import { $resetAuth } from './profile-entity';

export interface IMessage {
	id: number;
	clientId: string;
	buildId: string;
	sender: string;
	text: string;
	takeStatus?: 0 | 1 | 2 | 3;
	takenFrom?: string;
	comment?: string;
	createdAt: string | number;
	isOnline?: boolean;
	hasPhone?: boolean;
	phoneCountryCodes?: import('@crave/config/phone-country').PhoneCountryCode[];
	hasUnclassifiedNonEmptyPhone?: boolean;
}

export const $resetPanelState = createEvent();

export const $setIsFetchingMessages = createEvent<boolean>();
export const $isFetchingMessages = createStore<boolean>(false).on($setIsFetchingMessages, (_, payload) => payload).reset($resetPanelState);

export const $setHasMoreMessages = createEvent<boolean>();
export const $hasMoreMessages = createStore<boolean>(false).on($setHasMoreMessages, (_, payload) => payload).reset($resetPanelState);

export const $setCursorMessages = createEvent<string | null>();
export const $cursorMessages = createStore<string | null>(null).on($setCursorMessages, (_, payload) => payload).reset($resetPanelState);

export const $setMessages = createEvent<IMessage[]>();
export const $newMessage = createEvent<{ message: IMessage; sortDir: SortDir }>();
export const $addMessages = createEvent<IMessage[]>();
export const $updateMessagesByClientId = createEvent<Partial<IMessage> & { clientId: string }>();

export const $messages = createStore<IMessage[]>([])
	.on($setMessages, (_, payload) => payload)
	.on($addMessages, (state, payload) => [...state, ...payload])
	.on($newMessage, (state, { message, sortDir }) => {
		if (state.some(item => item.id === message.id)) return state;
		return sortDir === 'asc' ? [...state, message] : [message, ...state];
	})
	.on($updateMessagesByClientId, (state, payload) =>
		state.map(item => (item.clientId === payload.clientId ? { ...item, ...payload, id: item.id } : item)),
	)
	.reset($resetPanelState);

sample({
	clock: $resetAuth,
	target: $resetPanelState,
});
